import React, {Component, ReactElement, RefObject} from 'react'
import {Nullable} from '../../../app/TypeHelpers'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {
    ContentsMainTitle,
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    IconFont,
    MainContainer,
    Note,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv, StyledI, StyledImg} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint, Colors} from '../../../styledComponents/Constants'
import {THREAD_CATEGORY} from '../../../CodeMaster'
import {Box} from '@mui/material'
import {
    getFileExtension,
    getFileIconPath,
    getThreadContributorLabelFromSession,
    NatAsyncCallFunction,
} from '../../common/util/Natutil'
import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import {PlainBackLink} from '../../../styledComponents/Links'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {PrimaryStyledButton, SecondaryButton, SmallPlainLinkStyledButton} from '../../../styledComponents/Button'
import {
    DisplayBlockDiv,
    DisplayItemDiv,
    DisplayItemInput,
    DisplayItemInputLabel,
    DisplayItemInputLabelRequired,
    DisplayItemInputTitleRequired,
    DisplayItemTitle,
    FieldErrorLabel,
    TitleErrorLabel,
} from '../../../styledComponents/DisplayItem'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {RequestItemError} from '../../../network/response/RequestItemError'
import {
    CommentFile,
    CommentImage,
    NatPostBulletinBoardThreadCommentConfirm,
    NatPostBulletinBoardThreadCommentConfirmParams,
} from './repository/NatPostBulletinBoardThreadCommentConfirm'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import {Location, useLocation} from 'react-router-dom'

function withRouter<P extends object>(
    WrappedComponent: React.ComponentType<P>
): React.FC<P> {
    function RouterWrapper(props: P): JSX.Element {
        const location = useLocation();
        return <WrappedComponent{...props} location={location}/>;
    }

    return RouterWrapper;
}


interface FieldsError {
    comment: Error[]
    commentImage: Error[]
}

interface Error {
    message: string
    hasError: boolean
}

interface CommentFileError {
    errorKey: number
    errorMessage: string
}

type Field =
    'comment'
    | 'commentImage'


interface Props {
    threadCategoryId: string
    threadId: string
    bulletinBoardRepo: NatBulletinBoardRepo

    // TODO 型が不一致な気がする。一旦正しそうな「NatPostBulletinBoardThreadCommentConfirmParams」にした
    // location: H.Location<NatPostBulletinBoardThreadCommentConfirm>
    location: Location<NatPostBulletinBoardThreadCommentConfirmParams>
}


interface States {
    isLoadCompleted: boolean
    fieldsError: Partial<FieldsError>
    inputItemsComment: string
    inputItemsCommentImage: CommentImage[]
    inputItemsCommentFile: CommentFile[]
    selectedFileName: string
    selectedFileData: string | ArrayBuffer | null
    selectedFileSize: number
    publishFileName: string
    errorTitleMessage: string
    commentFileError: CommentFileError[]
}

class NatResidentBulletinBoardThreadCommentRegisterPage extends Component<Props & ResidentPagePropsSet, States> {
    commentImage: RefObject<HTMLInputElement>
    commentFile: RefObject<HTMLInputElement>
    threadCommentConfirmParamsState: NatPostBulletinBoardThreadCommentConfirmParams | null
    autoFocus: RefObject<HTMLInputElement>

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            isLoadCompleted: false,
            fieldsError: {},
            errorTitleMessage: '',
            inputItemsComment: '',
            inputItemsCommentImage: [],
            inputItemsCommentFile: [],
            selectedFileName: '',
            selectedFileData: '',
            selectedFileSize: 0,
            publishFileName: '',
            commentFileError: [],
        }
        this.autoFocus = React.createRef()
        this.commentImage = React.createRef()
        this.commentFile = React.createRef()

        const locationState = this.props.location.state
        this.threadCommentConfirmParamsState = (locationState) ? locationState : null

        this.clickComfirmButton = this.clickComfirmButton.bind(this)
        this.onChangeComment = this.onChangeComment.bind(this)
        this.judgeConfirmButtonDisabled = this.judgeConfirmButtonDisabled.bind(this)
        this.onChangeUploadImage = this.onChangeUploadImage.bind(this)
        this.onChangePublishFileName = this.onChangePublishFileName.bind(this)
        this.deleteImage = this.deleteImage.bind(this)
        this.deleteFile = this.deleteFile.bind(this)
        this.addCommentFile = this.addCommentFile.bind(this)
        this.judgeFileAddButtonDisabled = this.judgeFileAddButtonDisabled.bind(this)
        this.onChangeUploadFile = this.onChangeUploadFile.bind(this)

    }

    async componentDidMount(): Promise<void> {
        if (this.threadCommentConfirmParamsState) {
            const threadId: string = this.props.threadId
            const comment: string = this.threadCommentConfirmParamsState.comment
            const commentImage: CommentImage[] = this.threadCommentConfirmParamsState.commentImage
            const commentFile: CommentFile[] = this.threadCommentConfirmParamsState.commentFile

            this.setState({
                inputItemsComment: comment,
                inputItemsCommentImage: commentImage,
                inputItemsCommentFile: commentFile,
                isLoadCompleted: true,
            })
        } else {
            this.setState({isLoadCompleted: true})
        }

    }

    judgeConfirmButtonDisabled(): boolean {
        return !(this.state.inputItemsComment)
    }

    judgeFileAddButtonDisabled(): boolean {
        return !(this.state.selectedFileName &&
            this.state.publishFileName) || (this.state.inputItemsCommentFile.length >= 3)
    }

    onClickInputFile(elementId: string): void {
        const fileUpload = document.getElementById(elementId) as HTMLInputElement
        fileUpload.value = ''
        if (fileUpload) {
            fileUpload.click()
        }
    }

    onChangeUploadImage(event: React.ChangeEvent<HTMLInputElement>): void {
        // 画像情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            const reader: FileReader = new FileReader()
            const inputItemsCommentImage = this.state.inputItemsCommentImage
            const selectedCommentImage: CommentImage =
                {fileName: event.target.files[0].name, fileSize: event.target.files[0].size, fileData: ''}
            reader.onload = () => {
                selectedCommentImage.fileData = reader.result
                inputItemsCommentImage.push(selectedCommentImage)
                this.setState({inputItemsCommentImage: inputItemsCommentImage})
                // 追加したタイミングで選択した画像をクリア
                if (this.commentImage.current && this.commentImage.current.value) {
                    this.commentImage.current.value = ''
                }
            }
            reader.readAsDataURL(event.target.files[0])
        }
    }


    onChangeUploadFile(event: React.ChangeEvent<HTMLInputElement>): void {
        // ファイル情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {

            this.setState({
                selectedFileName: event.target.files[0].name,
                selectedFileSize: event.target.files[0].size,
            })

            const reader: FileReader = new FileReader()
            reader.onload = () => {
                this.setState({selectedFileData: reader.result})
            }
            reader.readAsDataURL(event.target.files[0])
        }
    }

    onChangeUploadFileSortOrder = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputItemsCommentFile = this.state.inputItemsCommentFile
        inputItemsCommentFile[index].sortOrder = Number(event.target.value)
        this.setState({inputItemsCommentFile: inputItemsCommentFile})
    }

    deleteImage(index: number): void {
        const inputItemsCommentImage = this.state.inputItemsCommentImage
        inputItemsCommentImage.splice(index, 1)
        this.setState({inputItemsCommentImage: inputItemsCommentImage})
    }

    deleteFile(index: number): void {
        const inputItemsCommentFile = this.state.inputItemsCommentFile
        inputItemsCommentFile.splice(index, 1)
        const commentFileError = this.state.commentFileError
        commentFileError.splice(index, 1)
        this.setState({
            inputItemsCommentFile: inputItemsCommentFile,
            commentFileError: commentFileError,
        })
    }

    onChangePublishFileName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({publishFileName: event.target.value})
    }

    addCommentFile(): void {
        const inputItemsCommentFile = this.state.inputItemsCommentFile
        const commentFile: CommentFile = {
            ['sortOrder']: inputItemsCommentFile.length + 1,
            ['fileName']: this.state.selectedFileName,
            ['fileSize']: this.state.selectedFileSize,
            ['fileData']: this.state.selectedFileData,
            ['publishFileName']: this.state.publishFileName,
        }
        inputItemsCommentFile.push(commentFile)
        this.setState({
            selectedFileName: '',
            selectedFileSize: 0,
            selectedFileData: '',
            publishFileName: '',
            inputItemsCommentFile: inputItemsCommentFile,
        })
        // 追加したタイミングで選択したファイルをクリア
        if (this.commentFile.current && this.commentFile.current.value) {
            this.commentFile.current.value = ''
        }
    }

    async clickComfirmButton(): Promise<void> {
        await this.clearMessage()
        await this.props.eventEmitter.showLoading()
        try {

            const inputItemsCommentImage: CommentImage[] = []
            if (this.state.inputItemsCommentImage) {
                this.state.inputItemsCommentImage.map((image) => {
                    if (image.fileData) {
                        const fileData: string[] = String(image.fileData).split(',')
                        if (fileData[1]) {
                            inputItemsCommentImage.push({
                                fileName: image.fileName,
                                fileData: fileData[1],
                                fileSize: image.fileSize,
                            })
                        }

                    }
                })
            }

            const inputItemsCommentFile: CommentFile[] = []
            if (this.state.inputItemsCommentFile) {
                this.state.inputItemsCommentFile.forEach((file, index) => {
                    if (file.fileData) {
                        const fileData: string[] = String(file.fileData).split(',')
                        if (fileData[1]) {
                            inputItemsCommentFile.push({
                                sortOrder: file.sortOrder,
                                publishFileName: file.publishFileName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            })
                        }

                    }
                })
            }


            const request: NatPostBulletinBoardThreadCommentConfirmParams = {
                threadId: this.props.threadId,
                comment: this.state.inputItemsComment,
                commentImage: inputItemsCommentImage,
                commentFile: inputItemsCommentFile,
            }

            const ret: Nullable<NatPostBulletinBoardThreadCommentConfirm> =
                await NatAsyncCallFunction(this.props.bulletinBoardRepo.postBulletinBoardThreadCommentConfirm.bind(
                    this.props.bulletinBoardRepo, request), this.props.navigate)

            if (!ret) {
                return
            }

            // 引継ぎ情報
            this.threadCommentConfirmParamsState = {
                threadId: this.props.threadId,
                comment: this.state.inputItemsComment,
                commentImage: this.state.inputItemsCommentImage,
                commentFile: this.state.inputItemsCommentFile,
            }

            this.props.navigate(
                `/resident/bulletinBoardThreadCommentConfirm/${this.props.threadCategoryId}/${this.props.threadId}`,
                {state: this.threadCommentConfirmParamsState},
            )


        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                errorResponseBody.requestItemErrors.forEach((item: RequestItemError) => {
                    if (item.fields) {
                        item.fields.forEach((field) => {
                            if (field.startsWith('commentFile')) {
                                const workFileNumber = field.split('[')[1]
                                const fileNumber = workFileNumber.split(']')[0]
                                const commentFileError: CommentFileError[] = this.state.commentFileError
                                commentFileError[Number(fileNumber)] =
                                    {errorKey: Number(fileNumber), errorMessage: item.message}
                                this.setState({commentFileError: commentFileError})
                            } else {
                                this.setFieldErrorMessage(field, item.message)
                            }

                        })
                    }
                    if (item.resultCode === 'commentImage') {
                        this.setFieldErrorMessage('commentImage', item.message)
                    }
                    if (item.resultCode.startsWith('commentFile')) {
                        for (const file of item.resultCode) {
                            const workFileNumber = item.resultCode.split('[')[1]
                            const fileNumber = workFileNumber.split(']')[0]
                            const commentFileError: CommentFileError[] = this.state.commentFileError
                            commentFileError[Number(fileNumber)] =
                                {errorKey: Number(fileNumber), errorMessage: item.message}
                            this.setState({commentFileError: commentFileError})
                        }
                    }
                })
                if (errorResponseBody.requestError !== null) {
                    this.setTitleErrorMessage(errorResponseBody.requestError.message)
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }


    onChangeComment(value: string): void {
        this.setState({inputItemsComment: value})
    }

    // フィールドエラー状態取得
    getFieldErrorStatus(fieldId: Field): boolean {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        return !!(field !== undefined && field[0] !== undefined && field[0].hasError)
    }

    // メッセージ取得（フィールド）
    getFieldErrorMessage(fieldId: Field): Nullable<ReactElement> {
        const field: Error[] | undefined = this.state.fieldsError[fieldId]
        if (field !== undefined) {
            return (
                <>
                    {field.map((error, index) => (
                        <FieldErrorLabel key={index}>
                            {error.message}
                        </FieldErrorLabel>
                    ))}
                </>
            )
        } else {
            return null
        }
    }

    setTitleErrorMessage(message: string): void {
        this.setState({errorTitleMessage: message})
    }

    getTitleErrorMessage(): Nullable<ReactElement> {
        if (this.state.errorTitleMessage !== '') {
            return (
                <TitleErrorLabel>
                    {this.state.errorTitleMessage}
                </TitleErrorLabel>
            )
        } else {
            return null
        }
    }

    renderCommentFileErrorMessage(fileKey: number): Nullable<ReactElement> {
        if (this.state.commentFileError[fileKey]) {
            return (
                <FieldErrorLabel key={`commentFileError_${fileKey}`}>
                    {this.state.commentFileError[fileKey].errorMessage}
                </FieldErrorLabel>
            )
        } else {
            return (<></>)
        }
    }

    // メッセージ設定（フィールド）
    setFieldErrorMessage(field: string, message: string): void {
        if (field === 'comment' || field === 'commentImage') {
            let error: Error[] | undefined = this.state.fieldsError[field]
            if (error === undefined) {
                error = [{message: message, hasError: true}]
            } else {
                error.push({message: message, hasError: true})
            }

            this.setState(({fieldsError}) => (
                {
                    fieldsError: {
                        ...fieldsError,
                        [field]: error,
                    },
                }))
        }
    }

    // メッセージクリア
    clearMessage(): void {
        this.setState({fieldsError: {}, errorTitleMessage: '', commentFileError: []})
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        let subTitle: string = ''
        const threadCategoryId: string | undefined = this.props.threadCategoryId;

        const threadCategoryCode: THREAD_CATEGORY =
            THREAD_CATEGORY.codeToEnumConstants(threadCategoryId ?? '0')
        if (threadCategoryCode) {
            subTitle = threadCategoryCode.label
        }

        return <>
            <ContentsMainTitle><TitleIcon/>情報交換掲示板</ContentsMainTitle>
            <ContentsSubTitleWrapper>
                <ContentsSubTitleInner>
                    {subTitle}
                </ContentsSubTitleInner>
            </ContentsSubTitleWrapper>

            <MainContainer>
                <DisplayItemTitle>コメント投稿</DisplayItemTitle>
                {this.getTitleErrorMessage()}
                <BlockSpacer height={'20px'}/>
                <DisplayBlockDiv>
                    <DisplayItemInputLabel>名前</DisplayItemInputLabel>
                    <Box mb={'8px'}></Box>
                    <DisplayItemDiv>{getThreadContributorLabelFromSession()}</DisplayItemDiv>
                </DisplayBlockDiv>
                <DisplayBlockDiv>
                    <DisplayItemInputLabelRequired>
                        <DisplayItemInputTitleRequired>コメント</DisplayItemInputTitleRequired>
                        <EditorStyleDiv hasError={this.getFieldErrorStatus('comment')}>
                            <PPHtmlEditor
                                init={{
                                    maxLength: 2000,
                                }}
                                onEditorChange={this.onChangeComment}
                                value={this.state.inputItemsComment ? this.state.inputItemsComment : ''}
                            />
                        </EditorStyleDiv>
                    </DisplayItemInputLabelRequired>
                    {this.getFieldErrorMessage('comment')}
                </DisplayBlockDiv>


                <DisplayBlockDiv>
                    <DisplayItemInputLabel>画像</DisplayItemInputLabel>
                    <Box mb={'8px'}></Box>

                    <SecondaryButton onClick={() => this.onClickInputFile('imageUpload')}
                                     disabled={(this.state.inputItemsCommentImage.length >= 4)}>
                        画像を選択
                    </SecondaryButton>
                    <DisplayNoneInput type={'file'} id={'imageUpload'} ref={this.commentImage}
                                      accept={'image/jpeg,image/png,image/gif'}
                                      onChange={this.onChangeUploadImage}/>
                    {this.getFieldErrorMessage('commentImage')}
                    <Note>※5MBまで</Note>

                    {(this.state.inputItemsCommentImage?.length ?? 0) > 0 ?
                        this.state.inputItemsCommentImage.map((commentImage, index) => (
                            <DisplayItemImageDiv key={`commentImage_${index}_${commentImage.fileName}`}>
                                <CommentImgDiv>
                                    <CommentImg src={String(commentImage.fileData)}
                                                alt={commentImage.fileName}/>
                                </CommentImgDiv>
                                <CommentImgDeleteDiv>
                                    <SmallPlainLinkStyledButton onClick={() => this.deleteImage(index)}>
                                        削除
                                    </SmallPlainLinkStyledButton>
                                </CommentImgDeleteDiv>
                            </DisplayItemImageDiv>
                        )) : <></>
                    }
                </DisplayBlockDiv>


                <DisplayBlockDiv>
                    <DisplayItemInputLabel>ファイル</DisplayItemInputLabel>
                    <Box mb={'8px'}></Box>
                    <DisplayItemDiv>ファイル名</DisplayItemDiv>
                    <Box mb={'8px'}></Box>
                    <DisplayItemInput
                        type="text"
                        id="publishFileName"
                        name="publishFileName"
                        accept={'application/vnd.ms-PowerPoint,application/vnd.ms-excel,application/msword,application/pdf'}
                        maxLength={50}
                        value={this.state.publishFileName}
                        onChange={this.onChangePublishFileName}
                        disabled={(this.state.inputItemsCommentFile?.length ?? 0) >= 3}
                    />
                    <Box mb={'8px'}></Box>

                    <SecondaryButton
                        onClick={() => this.onClickInputFile('fileUpload')}
                        disabled={(this.state.inputItemsCommentFile?.length ?? 0) >= 3}>
                        ファイルを選択
                    </SecondaryButton>
                    <DisplayNoneInput type={'file'} id={'fileUpload'} ref={this.commentFile}
                                      onChange={this.onChangeUploadFile}/>

                    <DisplayItemSelectedFileName>{this.state.selectedFileName}</DisplayItemSelectedFileName>
                    <Note>※5MBまで</Note>
                    <Note>
                        ※特定のファイル形式(.docx/.xlsx/.pptx/.pdf)以外は、アップロード出来ません。
                    </Note>
                    <Note>
                        ※Word、Excel、PPTファイルを投稿した場合、ご利用の端末によっては開けない場合がございます。
                    </Note>
                    <Box mb={'8px'}></Box>
                    <SecondaryButton onClick={this.addCommentFile} disabled={this.judgeFileAddButtonDisabled()}>
                        ファイルを追加
                    </SecondaryButton>

                    {(this.state.inputItemsCommentFile?.length ?? 0) > 0 ?
                        this.state.inputItemsCommentFile.map((commentFile, index) => (
                            <CommentFileDiv key={`threadFile${index}_${commentFile.fileName}`}>
                                <DisplayItemFileDiv>
                                    <FileIcon src={getFileIconPath(getFileExtension(commentFile.fileName))}
                                              alt={commentFile.fileName}/>
                                    <DisplayItemFileInfosDiv>
                                        <DisplayItemFileNameDiv>{commentFile.publishFileName}</DisplayItemFileNameDiv>
                                        <DisplayItemNonFileNameDiv>
                                            <DisplayItemFileSortOrderLabelDiv>並び順</DisplayItemFileSortOrderLabelDiv>
                                            <DisplayItemFileSortOrderDiv>
                                                <DisplayItemInput
                                                    type="number"
                                                    min={1}
                                                    max={999}
                                                    id={`inputItemsCommentFile_${index}`}
                                                    name={`inputItemsCommentFile_${index}`}
                                                    maxLength={3}
                                                    value={commentFile.sortOrder}
                                                    onChange={this.onChangeUploadFileSortOrder(index)}
                                                />
                                            </DisplayItemFileSortOrderDiv>
                                            <DisplayItemFileDeleteDiv>
                                                <SmallPlainLinkStyledButton onClick={() => this.deleteFile(index)}>
                                                    削除
                                                </SmallPlainLinkStyledButton>
                                            </DisplayItemFileDeleteDiv>
                                        </DisplayItemNonFileNameDiv>
                                    </DisplayItemFileInfosDiv>
                                </DisplayItemFileDiv>
                                {this.renderCommentFileErrorMessage(index)}
                            </CommentFileDiv>
                        )) : <></>
                    }
                </DisplayBlockDiv>


            </MainContainer>

            <Box mt={'30px'} mb={'15px'}>
                <PrimaryStyledButton
                    onClick={this.clickComfirmButton}
                    disabled={this.judgeConfirmButtonDisabled()}>
                    コメント内容を確認する
                </PrimaryStyledButton>
            </Box>
            <PlainBackLink to={`/resident/bulletinBoardThread/${this.props.threadId}`}>
                スレッド参照へ戻る
            </PlainBackLink>
        </>
    }
}

export default createResidentPage(withRouter(NatResidentBulletinBoardThreadCommentRegisterPage))

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

const TitleIcon: StyledI = styled.i`
  ${IconFont};
  font-size: 6.0rem;
  padding-right: 15px;
  color: #4dba78;

  &::before {
      content: "\f111";
  }
`

const DisplayNoneInput = styled.input`
  display: none;
`

const DisplayItemImageDiv = styled(DisplayItemDiv)`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const DisplayItemSelectedFileName = styled(DisplayItemDiv)`
  color: grey;
  margin: 8px 0;
`

const CommentImgDiv: StyledDiv = styled.div`
  flex-basis: 50%;
`

const CommentImg: StyledImg = styled.img`
  max-width: 100%;
  max-height: 30vh;
`

const CommentFileDiv: StyledDiv = styled.div`
`

const FileIcon: StyledImg = styled.img`
  ${breakPoint.lessThan('sp')`
    max-width: 150%;
  `}
`

const CommentImgDeleteDiv: StyledDiv = styled.div`
  flex-basis: 50%;
  text-align: center;
`

const DisplayItemFileDiv = styled(DisplayItemDiv)`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`


const DisplayItemFileIconDiv = styled(DisplayItemDiv)`
  flex-basis: 20%;
  ${breakPoint.lessThan('sp')`
    margin-left: 0;
  `}
`

const DisplayItemFileNameDiv = styled(DisplayItemDiv)`
  flex-basis: 50%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 100%;
  `}
`

const DisplayItemFileSortOrderLabelDiv = styled(DisplayItemDiv)`
  flex-basis: 60%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 40%;
  `}
`

const DisplayItemFileSortOrderDiv = styled(DisplayItemDiv)`
  flex-basis: 20%;
  ${breakPoint.lessThan('sp')`
    flex-basis: 40%;
  `}
`

const DisplayItemFileDeleteDiv = styled(DisplayItemDiv)`
  flex-basis: 20%;
  text-align: center;
  ${breakPoint.lessThan('sp')`
    flex-basis: 20%;
  `}
`

const DisplayItemFileInfosDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center
  ${breakPoint.lessThan('sp')`
    flex-direction: column;
    padding-left: 10px;
    align-items: flex-start;
  `}
`

const DisplayItemNonFileNameDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

interface InputCommentErrorProps {
    hasError?: Nullable<boolean>;
}

const EditorStyleDiv = styled.div<InputCommentErrorProps>`
  ${props => props.hasError === true ? `border: ${Colors.Alert} 1px solid` : ``};

  & .tox-edit-area__iframe {
    ${props => props.hasError === true ? `background-color: rgba(215, 55, 74, 0.05) !important` : ``};
  }
`
